export default {
    INTERNO: 1,
    EXTERNO: 2,
    AMBOS: 3,
}